import { SxProps, Theme } from "@mui/material";

/**
 * The editor's field grid, from the prototype's own `twoColStyle`:
 * `repeat(2, minmax(0, 1fr))`, 16px gap, `align-items: start`; one column on a phone.
 *
 * `minmax(0, 1fr)` rather than `1fr` for the reason README decision 17 records about flex: a grid
 * track's default `min-width: auto` lets a long value push the column wider than its share.
 */
export const ENTITY_FIELD_GRID_SX: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
  gap: 2,
  alignItems: "start",
};

/** Additional description spans the grid — it is a textarea, and it reads badly at half width. */
export const ENTITY_FULL_ROW_SX: SxProps<Theme> = {
  gridColumn: { sm: "1 / -1" },
};

/**
 * A closed list and the free text behind its `Other`, sharing **one** grid cell — the prototype's
 * `pairRowStyle`. Letting the free text take the next cell instead would push model off make's row
 * the moment `Other` is picked, which is the layout the design rules out.
 */
export const ENTITY_PAIR_ROW_SX: SxProps<Theme> = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  gap: 2,
  alignItems: "flex-start",
};

/** Each half of a pair row. `minWidth: 0` for the reason the grid uses `minmax(0, 1fr)`. */
export const ENTITY_PAIR_HALF_SX: SxProps<Theme> = { flex: 1, minWidth: 0 };
